export default {
  home: {
    title: "Training"
  }
};
